export default "__VITE_PUBLIC_ASSET__86b20c77__"